import React, { useState, useEffect } from 'react';
import FileList from './FileList';
import PermissionRequest from './PermissionRequest';

function DownloadSecured({user}) {
  const [files, setFiles] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [requestSent, setRequestSent] = useState(false);
  const [downloadToken, setDownloadToken] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    fetch('/api/files')
      .then(response => response.json())
      .then(data => setFiles(data))
      .catch(error => console.error('Error fetching files:', error));
  }, []);

  const handleFileSelect = (file) => {
    setSelectedFile(file);
    setRequestSent(false);
    setErrorMessage(null);
    // Check if we already have a token for this file in URL
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (token) {
      setDownloadToken(token);
    }
  };

  const handlePermissionRequest = (email, password) => {
    console.log("email, password---",email, password)
    fetch('/api/request-permission', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        file_id: selectedFile.id,
        email: email,
        password: password
      }),
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        setRequestSent(true);
        setErrorMessage(null);
      } else if (data.message === "Unknown User") {
        setErrorMessage("You are not registered for the 6th KRPC program. Please contact the program coordinator at stemx365org@gmail.com.");
        setRequestSent(false);
      }
    })
    .catch(error => console.error('Error requesting permission:', error));
  };

  return (
    <div className="file_download container d-flex flex-column" style={{ maxWidth: '800px', margin: '0 auto' }}>
    <header className="text-center mb-4">
      <h1 className="display-4">Secure File Download</h1>
    </header>
    <main className="card p-4">
      <FileList 
        files={files} 
        onFileSelect={handleFileSelect} 
        selectedFile={selectedFile}
        className="mb-4"
      />
      
      {selectedFile && (
        <div className="file-details card-body">
          <h2 className="h4 mb-3">{selectedFile.name}</h2>
          <p className="mb-3">Size: {(selectedFile.size / 1024).toFixed(2)} KB</p>
          
          {downloadToken ? (
            <a 
              href={`http://localhost:5000/api/download/${selectedFile.id}?token=${downloadToken}`}
              className="download-button btn btn-primary btn-lg w-100"
            >
              Download Now
            </a>
          ) : requestSent ? (
            <div className="request-sent alert alert-info">
              <p className="mb-0">Your request has been sent to the admin. You'll receive an email when approved.</p>
            </div>
          ) : errorMessage ? (
            <div className="error-message alert alert-danger">
              <p className="mb-0">{errorMessage}</p>
            </div>
          ) : (
            <PermissionRequest 
              onSubmit={handlePermissionRequest} 
            />
          )}
        </div>
      )}
    </main>
  </div>
  );
}

export default DownloadSecured;